import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { environment } from '../../../environments/default/environment';
import { Module } from '@shared/enums/Module';

@Injectable()
export class ModuleActiveGuard {
    canLoad(route: Route): boolean {
        const module: Module = route.data?.module;
        return !module || environment.projectConfiguration.modules.includes(module);
    }
}
